import React, { useEffect, useMemo } from "react";
import FormContact from "./FormContact";
import ScrollIndicator from "./ScrollIndicator";
import useScrollToTop from "../../hooks/useScollToTop";
import { useUser } from "./UserContext";
import { saveVisite } from "../../services/visitesServices";

import HomeHeroSection from "./HomeHeroSection";
import AgendaHome from "./AgendaHome";
import ResultatsHome from "./ResultatsHome";
import PassageGradeHome from "./PassageGradeHome";
import RecentPalmares from "./RecentPalmares";
import TechniquesFavoritesHome from "./TechniquesFavoritesHome";
import DiaporamaJudoCoachPro from "./../PagesJudokas/PricingPage/DiaporamaJudoCoachPro";
import AboutHome from "./AboutHome";

const getRoleId = (user) => {
  const value = user?.role_id ?? user?.roleId ?? user?.RoleId ?? user?.role?.id;
  const numeric = Number(value);

  return Number.isFinite(numeric) ? numeric : null;
};

const getHomeMode = (user) => {
  if (!user) return "visitor";

  const roleId = getRoleId(user);

  if (roleId === 1 || roleId === 3 || [5, 6, 7].includes(roleId)) {
    return "coach";
  }

  return "judoka";
};

function HomePageVitrine() {
  useScrollToTop();

  const { user } = useUser();

  const isConnected = Boolean(user);
  const homeMode = useMemo(() => getHomeMode(user), [user]);

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    const lastVisitDate = localStorage.getItem("lastVisitDate");

    if (lastVisitDate !== today) {
      saveVisite({})
        .then(() => {
          localStorage.setItem("lastVisitDate", today);
        })
        .catch((error) => {
          console.error(
            "Erreur lors de l'enregistrement de la visite :",
            error
          );
        });
    }
  }, []);

  return (
    <main className="min-h-screen overflow-hidden bg-[#f8fafc] pt-[78px] font-ui text-slate-950 dark:bg-[#070b14] dark:text-white">
      <ScrollIndicator />

      <HomeHeroSection user={user} mode={homeMode} />

      {!isConnected && <AboutHome />}

      <section
        id="agenda"
        className="relative bg-[#f8fafc] dark:bg-[#070b14]"
      >
        <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-white/80 to-transparent dark:from-[#070b14]" />

        <div className="relative z-10">
          <AgendaHome isConnected={isConnected} />
        </div>
      </section>

      <section className="bg-white dark:bg-[#0b1220]">
        <ResultatsHome isConnected={isConnected} />
      </section>

      <section className="bg-[#f8fafc] dark:bg-[#070b14]">
        <RecentPalmares isConnected={isConnected} />
      </section>

      <section className="bg-white dark:bg-[#0b1220]">
        <PassageGradeHome isConnected={isConnected} />
      </section>

      <section className="bg-[#f8fafc] dark:bg-[#070b14]">
        <TechniquesFavoritesHome isConnected={isConnected} />
      </section>

      {/* <section className="bg-white dark:bg-[#0b1220]">
        <DiaporamaJudoCoachPro />
      </section> */}

      <div id="contact">
        <FormContact />
      </div>
    </main>
  );
}

export default HomePageVitrine;